import { Component, OnInit, OnDestroy} from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IOperation } from '../airport-interfaces';

import { AirportService } from '../airport.service';
import { IScenario, ScenarioService } from '../../scenario-activities/scenario.service';

import { UserSession } from '../../shared/user-session';
import { UserInfoService } from '../../shared/user-info.service';

import { Button } from 'primeng/primeng';
import { Dialog } from 'primeng/primeng';

import {SystemControl} from '../../shared/system-control';
import {SystemControlElem} from '../../shared/system-control-elem';
import { SystemControlService } from '../../shared/system-control.service';



import * as _ from 'lodash';


@Component({
    template: require('./operations-add-data-point.component.html'),
    styles: [require('../airport.css')],
    directives: [ROUTER_DIRECTIVES, Button, Dialog]
})

export class OperationsAddDataPointComponent implements OnInit, OnDestroy{
    pageTitle: string;
    errorMessage: string;
    private sub: any;    
    currentScenario: IScenario;
    allScenarios: IScenario[];

    tableName: string;
    locId: string;
    year: number;
    airportName: string;
    systemControlElem: SystemControlElem;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _airportService: AirportService,
                private _scenarioService: ScenarioService, 
                private User: UserSession, 
                private _userInfoService: UserInfoService,
                private _systemControlService:SystemControlService) {
    }


    ngOnInit(): void{
        this.sub = this.route.params.subscribe(
            params => {
                this.tableName = params['tableName'];
                this.locId = params['locId'];
                this.airportName = params['airportName'];
            }
        );

        this._scenarioService.getScenarios(this.User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                }
            );

        this._systemControlService.getSystemControl()
            .subscribe(
                systemControlElem => this.systemControlElem = systemControlElem,
                error => this.errorMessage = <any>error
            );
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
    }

    submit(){

        this.errorMessage = null;

        if(this.year >= this.systemControlElem.lfcYear){
            this.errorMessage = "The year can only be less than last forecast year";
            return;
        }
        else{

            
            let scenarioId: number;

            if(this.year < this.systemControlElem.ffcYear){
                scenarioId = 0;
            }
            else{
                scenarioId = this.User.getSession().scenarioId; 
            }


            let params = {
                tableName: this.tableName,
                locId: this.locId,
                scenario: scenarioId,
                ayear: this.year
            }

            this._airportService.saveOperationsYear(params)
                .subscribe(
                    response => {
                        if(response.responseStatus == "success"){

                            
                            let displayAll: number = 0;

                            if(this.year < this.systemControlElem.ffcYear - 4){
                                displayAll = 1;
                            }

                            let params = {
                                locId: this.locId,
                                airportName: this.airportName,
                                displayAll: displayAll 
                            }

                            this.router.navigate([`/operations-list/${this.tableName}`, params]);

                        }
                        else if(response.responseStatus == "duplicate"){
                            this.errorMessage = "This year already exist within this scenario.";
                        }
                        else if(response.responseStatus == "error"){
                            this.errorMessage = "An error occured while trying to update the facility.";
                            console.error(response.responseMessage);
                        }
                    },
                    error => {
                        this.errorMessage = "An error occured while trying to add the year.";
                        console.error(error);
                    }
                );
        }
    }

    cancel(){
        let params = {
            locId: this.locId,
            airportName: this.airportName
        }

        this.router.navigate([`/operations-list/${this.tableName}`, params]);
    }

}



/** WEBPACK FOOTER **
 ** ./app/airports/Operations-lists/operations-add-data-point.component.ts
 **/